// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__3c6w_","subContainer":"Hero_subContainer__9sn6q","title":"Hero_title__3elVi","description":"Hero_description__2HKIW","image":"Hero_image__2j-ON"};